import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireRole } from '@/lib/routeGuards';

/** Layout-гард кабинета администратора: /admin/* доступен admin и owner. */
export const Route = createFileRoute('/_authed/admin')({
  beforeLoad: () => requireRole('admin', 'owner'),
  component: Outlet,
});
